const CountryCoords = () => {
    return {
      "Andorra": {
        "centroid": [42.5419, 1.5897],
        "zoom": 6
      },
      "United Arab Emirates": {
        "centroid": [24.3618, 55.1483],
        "zoom": 7
      },
      "Afghanistan": {
        "centroid": [34.0569, 65.7792],
        "zoom": 6
      },
      "Antigua and Barbuda": {
        "centroid": [17.0856, -61.7945],
        "zoom": 6
      },
      "Anguilla": {
        "centroid": [18.218, -63.04],
        "zoom": 6
      },
      "Albania": {
        "centroid": [41.1701, 20.0221],
        "zoom": 6
      },
      "Armenia": {
        "centroid": [40.0811, 44.8409],
        "zoom": 6
      },
      "Angola": {
        "centroid": [-12.005, 18.8562],
        "zoom": 6
      },
      "Antarctica": {
        "centroid": [-78.4168, 63.6432],
        "zoom": 6
      },
      "Argentina": {
        "centroid": [-38.6977, -64.9931],
        "zoom": 5
      },
      "American Samoa": {
        "centroid": [-14.3063, -170.7595],
        "zoom": 6
      },
      "Austria": {
        "centroid": [47.7132, 14.7922],
        "zoom": 6
      },
      "Australia": {
        "centroid": [-25.7566, 133.5282],
        "zoom": 6
      },
      "Aruba": {
        "centroid": [12.5176, -69.9818],
        "zoom": 6
      },
      "Åland Islands": {
        "centroid": [60.1993, 19.9087],
        "zoom": 6
      },
      "Azerbaijan": {
        "centroid": [40.176, 47.7228],
        "zoom": 6
      },
      "Bosnia Herzegovina": {
        "centroid": [43.9344, 17.9371],
        "zoom": 6
      },
      "Barbados": {
        "centroid": [13.1898, -59.559],
        "zoom": 8
      },
      "Bangladesh": {
        "centroid": [23.723, 89.8602],
        "zoom": 6
      },
      "Belgium": {
        "centroid": [50.5117, 4.8639],
        "zoom": 6
      },
      "Burkina Faso": {
        "centroid": [12.2601, -1.1849],
        "zoom": 6
      },
      "Bulgaria": {
        "centroid": [42.7429, 25.195],
        "zoom": 6
      },
      "Bahrain": {
        "centroid": [26.0251, 50.5532],
        "zoom": 8.5
      },
      "Burundi": {
        "centroid": [-3.3908, 29.9472],
        "zoom": 6
      },
      "Benin": {
        "centroid": [9.3333, 2.283],
        "zoom": 6
      },
      "Saint Barthelemy": {
        "centroid": [17.9036, -62.8117],
        "zoom": 6
      },
      "Bermuda": {
        "centroid": [32.3022, -64.7741],
        "zoom": 6
      },
      "Brunei Darussalam": {
        "centroid": [4.5256, 114.5238],
        "zoom": 6
      },
      "Bolivia": {
        "centroid": [-17.5949, -64.5157],
        "zoom": 6
      },
      "Bonaire, Sint Eustatius and Saba": {
        "centroid": [12.1686, -68.2468],
        "zoom": 6
      },
      "Brazil": {
        "centroid": [-15.1285, -57.772],
        "zoom": 5
      },
      "Bahamas": {
        "centroid": [24.7032, -78.0455],
        "zoom": 6
      },
      "Bhutan": {
        "centroid": [27.473, 90.3415],
        "zoom": 6
      },
      "Bouvet Island": {
        "centroid": [-54.4197, 3.3595],
        "zoom": 6
      },
      "Botswana": {
        "centroid": [-22.4176, 24.4739],
        "zoom": 6
      },
      "Belarus": {
        "centroid": [53.7747, 27.883],
        "zoom": 6
      },
      "Belize": {
        "centroid": [17.1949, -88.7271],
        "zoom": 7
      },
      "Canada": {
        "centroid": [60.2263, -116.9299],
        "zoom": 6
      },
      "Cocos (Keeling) Islands (the)": {
        "centroid": [-12.171, 96.8303],
        "zoom": 6
      },
      "Democratic Republic of the Congo": {
        "centroid": [-4.0875, 22.4374],
        "zoom": 6
      },
      "Central African Republic": {
        "centroid": [6.6414, 20.6666],
        "zoom": 6
      },
      "Republic of the Congo": {
        "centroid": [-0.6664, 16.0718],
        "zoom": 6
      },
      "Switzerland": {
        "centroid": [46.8224, 8.4481],
        "zoom": 6
      },
      "Côte d'Ivoire": {
        "centroid": [7.5616, -5.5573],
        "zoom": 6
      },
      "Cook Islands": {
        "centroid": [-21.2339, -159.7783],
        "zoom": 6
      },
      "Chile": {
        "centroid": [-37.8958, -72.3188],
        "zoom": 5
      },
      "Cameroon": {
        "centroid": [7.4045, 13.6386],
        "zoom": 6
      },
      "China": {
        "centroid": [38.8017, 95.6715],
        "zoom": 6
      },
      "Colombia": {
        "centroid": [4.1608, -72.6455],
        "zoom": 6
      },
      "Costa Rica": {
        "centroid": [9.6333, -83.6678],
        "zoom": 7
      },
      "Cuba": {
        "centroid": [21.5254, -77.8291],
        "zoom": 6
      },
      "Cape Verde": {
        "centroid": [15.1204, -23.6351],
        "zoom": 6
      },
      "Curaçao": {
        "centroid": [12.2132, -69.0406],
        "zoom": 6
      },
      "Christmas Island": {
        "centroid": [-10.4914, 105.6169],
        "zoom": 6
      },
      "Cyprus": {
        "centroid": [35.1661, 33.3986],
        "zoom": 6
      },
      "Czech Republic": {
        "centroid": [49.8197, 15.5271],
        "zoom": 6
      },
      "Abu Musa Island": {
        "centroid": [25.8779, 55.0306],
        "zoom": 6
      },
      "Greater Tunb Island": {
        "centroid": [26.2649, 55.3051],
        "zoom": 6
      },
      "Nagorno-Karabakh": {
        "centroid": [39.6461, 46.7149],
        "zoom": 6
      },
      "Rincón de Artigas": {
        "centroid": [-30.9757, -55.9486],
        "zoom": 6
      },
      "Kula Kangri": {
        "centroid": [28.2113, 90.2383],
        "zoom": 6
      },
      "Doklam Plateau": {
        "centroid": [27.5135, 89.0081],
        "zoom": 6
      },
      "Arunachal Pradash": {
        "centroid": [28.1416, 94.0334],
        "zoom": 6
      },
      "Trans-Karakoram Tract": {
        "centroid": [35.9534, 76.4574],
        "zoom": 6
      },
      "Aksai Chin disputed area": {
        "centroid": [34.697, 79.1217],
        "zoom": 6
      },
      "Demchok disputed area": {
        "centroid": [32.8792, 79.3519],
        "zoom": 6
      },
      "Chumar East disputed area": {
        "centroid": [32.683, 78.7079],
        "zoom": 6
      },
      "Chumar disputed area": {
        "centroid": [32.6215, 78.6045],
        "zoom": 6
      },
      "Kauirik disputed area": {
        "centroid": [32.0285, 78.6587],
        "zoom": 6
      },
      "Shipki Pass disputed area": {
        "centroid": [31.3804, 78.791],
        "zoom": 6
      },
      "Jadh-Nelang disputed area": {
        "centroid": [31.2045, 79.1259],
        "zoom": 6
      },
      "Lapthal-Bara Hoti disputed area": {
        "centroid": [30.7827, 80.028],
        "zoom": 6
      },
      "Senkaku Islands": {
        "centroid": [25.743, 123.4764],
        "zoom": 6
      },
      "Spratly Islands": {
        "centroid": [8.1846, 113.3158],
        "zoom": 6
      },
      "Pratas Island": {
        "centroid": [20.7035, 116.7287],
        "zoom": 6
      },
      "Paracel Islands": {
        "centroid": [16.2212, 111.7015],
        "zoom": 6
      },
      "United Nations-administered buffer zone": {
        "centroid": [35.0947, 32.9281],
        "zoom": 6
      },
      "Hala'ib Triangle": {
        "centroid": [22.5762, 35.5497],
        "zoom": 6
      },
      "Bir Tawil": {
        "centroid": [21.8656, 33.6971],
        "zoom": 6
      },
      "Abkhazia": {
        "centroid": [42.9915, 41.4577],
        "zoom": 6
      },
      "South Ossetia": {
        "centroid": [42.385, 44.0818],
        "zoom": 6
      },
      "French Guiana–Suriname disputed area": {
        "centroid": [2.7239, -54.1343],
        "zoom": 6
      },
      "Tigri Area": {
        "centroid": [2.4457, -57.3612],
        "zoom": 6
      },
      "East Jerusalem": {
        "centroid": [31.7959, 35.2419],
        "zoom": 6
      },
      "Golan Heights": {
        "centroid": [33.008, 35.749],
        "zoom": 6
      },
      "Kalapani-Lympiadhura disputed area": {
        "centroid": [30.3206, 80.7744],
        "zoom": 6
      },
      "Susta disputed area": {
        "centroid": [27.3922, 83.8659],
        "zoom": 6
      },
      "Pakistan-administered Kashmir": {
        "centroid": [34.9569, 75.4563],
        "zoom": 6
      },
      "Indian-administered Kashmir": {
        "centroid": [33.9882, 76.503],
        "zoom": 6
      },
      "Liancourt Rocks": {
        "centroid": [37.242, 131.8648],
        "zoom": 6
      },
      "Kuril Islands": {
        "centroid": [44.9901, 147.8445],
        "zoom": 6
      },
      "Ilemi Triangle": {
        "centroid": [4.6551, 35.7462],
        "zoom": 6
      },
      "Abyei": {
        "centroid": [9.7168, 28.4279],
        "zoom": 6
      },
      "Kafia Kingi": {
        "centroid": [9.2602, 24.1191],
        "zoom": 6
      },
      "Germany": {
        "centroid": [51.3283, 10.5806],
        "zoom": 6
      },
      "Djibouti": {
        "centroid": [11.8131, 42.5037],
        "zoom": 6
      },
      "Denmark": {
        "centroid": [55.9565, 9.3144],
        "zoom": 6
      },
      "Dominica": {
        "centroid": [15.4238, -61.3416],
        "zoom": 8
      },
      "Dominican Republic": {
        "centroid": [18.772, -70.1245],
        "zoom": 7
      },
      "Algeria": {
        "centroid": [28.4186, 0.5929],
        "zoom": 6
      },
      "Ecuador": {
        "centroid": [-1.7987, -78.2725],
        "zoom": 6
      },
      "Estonia": {
        "centroid": [58.6092, 25.3668],
        "zoom": 6
      },
      "Egypt": {
        "centroid": [26.9406, 29.4676],
        "zoom": 6
      },
      "Western Sahara": {
        "centroid": [24.2721, -13.686],
        "zoom": 6
      },
      "Eritrea": {
        "centroid": [15.2, 38.0893],
        "zoom": 6
      },
      "Spain": {
        "centroid": [40.0069, -3.4202],
        "zoom": 6
      },
      "Ethiopia": {
        "centroid": [9.1927, 38.971],
        "zoom": 6
      },
      "Finland": {
        "centroid": [65.4504, 27.5283],
        "zoom": 6
      },
      "Fiji": {
        "centroid": [-17.7941, 177.9784],
        "zoom": 6
      },
      "Falkland Islands (Islas Malvinas)": {
        "centroid": [-51.8, -58.6015],
        "zoom": 6
      },
      "Micronesia": {
        "centroid": [6.8852, 158.2402],
        "zoom": 6
      },
      "Faroe": {
        "centroid": [62.1243, -7.0162],
        "zoom": 6
      },
      "France": {
        "centroid": [46.8894, 2.1593],
        "zoom": 6
      },
      "Gabon": {
        "centroid": [-0.8204, 11.6604],
        "zoom": 6
      },
      "United Kingdom": {
        "centroid": [54.5473, -2.1839],
        "zoom": 6
      },
      "Grenada": {
        "centroid": [12.1111, -61.6866],
        "zoom": 6
      },
      "Georgia": {
        "centroid": [42.3325, 43.6774],
        "zoom": 6
      },
      "French Guiana": {
        "centroid": [3.9307, -53.0339],
        "zoom": 6
      },
      "Guernsey": {
        "centroid": [49.4632, -2.5827],
        "zoom": 6
      },
      "Ghana": {
        "centroid": [7.9674, -1.0593],
        "zoom": 6
      },
      "Gibraltar": {
        "centroid": [36.134, -5.3482],
        "zoom": 6
      },
      "Greenland": {
        "centroid": [76.1035, -40.299],
        "zoom": 6
      },
      "Gambia": {
        "centroid": [13.4345, -15.9739],
        "zoom": 6
      },
      "Guinea": {
        "centroid": [9.9448, -9.6618],
        "zoom": 6
      },
      "Guadeloupe": {
        "centroid": [16.1544, -61.6781],
        "zoom": 8
      },
      "Equatorial Guinea": {
        "centroid": [1.6349, 10.4695],
        "zoom": 6
      },
      "Greece": {
        "centroid": [39.1182, 21.7609],
        "zoom": 6
      },
      "South Georgia and the South Sandwich Islands": {
        "centroid": [-54.4399, -36.4992],
        "zoom": 6
      },
      "Guatemala": {
        "centroid": [15.788, -90.296],
        "zoom": 7
      },
      "Guam": {
        "centroid": [13.4504, 144.7577],
        "zoom": 6
      },
      "Guinea-Bissau": {
        "centroid": [11.805, -14.5964],
        "zoom": 6
      },
      "Guyana": {
        "centroid": [4.8627, -58.9504],
        "zoom": 6
      },
      "香港": {
        "centroid": [22.4114, 114.0599],
        "zoom": 6
      },
      "Heard and McDonald Islands": {
        "centroid": [-53.0783, 73.5286],
        "zoom": 6
      },
      "Honduras": {
        "centroid": [14.5107, -87.2196],
        "zoom": 7
      },
      "Croatia": {
        "centroid": [44.7753, 15.3255],
        "zoom": 6
      },
      "Haiti": {
        "centroid": [18.9899, -72.295],
        "zoom": 7
      },
      "Hungary": {
        "centroid": [47.1808, 19.1494],
        "zoom": 6
      },
      "Indonesia": {
        "centroid": [0.1133, 113.3193],
        "zoom": 6
      },
      "Ireland": {
        "centroid": [53.4608, -8.1124],
        "zoom": 6
      },
      "Israel": {
        "centroid": [31.034, 34.665],
        "zoom": 7.5
      },
      "Isle of Man": {
        "centroid": [54.2362, -4.5149],
        "zoom": 6
      },
      "India": {
        "centroid": [22.5605, 79.5556],
        "zoom": 6
      },
      "British Indian Ocean Territory (the)": {
        "centroid": [-7.3392, 72.4716],
        "zoom": 6
      },
      "Iraq": {
        "centroid": [33.3185, 42.461],
        "zoom": 6
      },
      "Iran": {
        "centroid": [32.719, 53.7474],
        "zoom": 6
      },
      "Iceland": {
        "centroid": [65.0123, -18.32],
        "zoom": 6
      },
      "Italy": {
        "centroid": [42.6733, 12.5134],
        "zoom": 6
      },
      "Jersey": {
        "centroid": [49.2127, -2.1257],
        "zoom": 6
      },
      "Jamaica": {
        "centroid": [18.1159, -77.1598],
        "zoom": 7
      },
      "Jordan": {
        "centroid": [31.3051, 36.3091],
        "zoom": 7
      },
      "Japan": {
        "centroid": [37.6006, 139.8855],
        "zoom": 6
      },
      "Kenya": {
        "centroid": [0.175, 37.4844],
        "zoom": 6
      },
      "Kyrgyzstan": {
        "centroid": [41.2558, 75.0168],
        "zoom": 6
      },
      "Cambodia": {
        "centroid": [12.5575, 105.1334],
        "zoom": 6
      },
      "Kiribati": {
        "centroid": [1.8709, -157.371],
        "zoom": 6
      },
      "Comoros": {
        "centroid": [-11.6527, 43.3307],
        "zoom": 6
      },
      "Saint Kitts and Nevis": {
        "centroid": [17.3157, -62.7447],
        "zoom": 6
      },
      "North Korea": {
        "centroid": [40.3963, 126.8405],
        "zoom": 6
      },
      "South Korea": {
        "centroid": [36.4836, 127.958],
        "zoom": 6
      },
      "Kuwait": {
        "centroid": [29.3169, 47.4272],
        "zoom": 8
      },
      "Cayman Islands": {
        "centroid": [19.3299, -81.1713],
        "zoom": 6
      },
      "Kazakhstan": {
        "centroid": [48.5488, 66.572],
        "zoom": 6
      },
      "Laos": {
        "centroid": [18.2605, 102.1591],
        "zoom": 6
      },
      "Lebanon": {
        "centroid": [33.878, 35.9001],
        "zoom": 7.5
      },
      "Saint Lucia": {
        "centroid": [13.9091, -60.9779],
        "zoom": 8
      },
      "Liechtenstein": {
        "centroid": [47.1593, 9.547],
        "zoom": 6
      },
      "Sri Lanka": {
        "centroid": [7.8836, 80.6383],
        "zoom": 6
      },
      "Liberia": {
        "centroid": [6.456, -9.6382],
        "zoom": 6
      },
      "Lesotho": {
        "centroid": [-29.6287, 28.1744],
        "zoom": 6
      },
      "Lithuania": {
        "centroid": [55.195, 24.1282],
        "zoom": 6
      },
      "Luxembourg": {
        "centroid": [49.8167, 6.0814],
        "zoom": 6
      },
      "Latvia": {
        "centroid": [56.9003, 24.4397],
        "zoom": 6
      },
      "Libya": {
        "centroid": [26.5829, 17.4424],
        "zoom": 6
      },
      "Morocco": {
        "centroid": [31.8889, -6.1699],
        "zoom": 6
      },
      "Monaco": {
        "centroid": [43.7382, 7.4241],
        "zoom": 6
      },
      "Moldova": {
        "centroid": [47.0019, 28.8269],
        "zoom": 6
      },
      "Montenegro": {
        "centroid": [42.7151, 19.2878],
        "zoom": 6
      },
      "Saint Martin": {
        "centroid": [18.0848, -63.0505],
        "zoom": 6
      },
      "Madagascar": {
        "centroid": [-18.9175, 46.6872],
        "zoom": 6
      },
      "Marshall Islands": {
        "centroid": [7.109, 171.3717],
        "zoom": 6
      },
      "North Macedonia": {
        "centroid": [41.6182, 21.7483],
        "zoom": 6
      },
      "Mali": {
        "centroid": [17.4996, -0.725],
        "zoom": 6
      },
      "Myanmar": {
        "centroid": [19.5274, 95.9058],
        "zoom": 6
      },
      "Mongolia": {
        "centroid": [47.1285, 105.2046],
        "zoom": 6
      },
      "澳门": {
        "centroid": [22.1404, 113.5643],
        "zoom": 6
      },
      "Northern Mariana Islands (the)": {
        "centroid": [15.191, 145.7468],
        "zoom": 6
      },
      "Martinique": {
        "centroid": [14.6368, -61.0157],
        "zoom": 8
      },
      "Mauritania": {
        "centroid": [21.1503, -11.4608],
        "zoom": 6
      },
      "Montserrat": {
        "centroid": [16.7492, -62.1917],
        "zoom": 6
      },
      "Malta": {
        "centroid": [35.9023, 14.4137],
        "zoom": 6
      },
      "Mauritius": {
        "centroid": [-20.2529, 57.5899],
        "zoom": 6
      },
      "Maldives": {
        "centroid": [-0.6321, 73.1],
        "zoom": 6
      },
      "Malawi": {
        "centroid": [-13.2731, 33.7428],
        "zoom": 6
      },
      "Mexico": {
        "centroid": [23.944, -102.3696],
        "zoom": 6
      },
      "Malaysia": {
        "centroid": [3.9518, 114.6584],
        "zoom": 6
      },
      "Mozambique": {
        "centroid": [-18.8696, 34.3703],
        "zoom": 6
      },
      "Namibia": {
        "centroid": [-23.107, 17.213],
        "zoom": 6
      },
      "New Caledonia": {
        "centroid": [-21.24, 165.2478],
        "zoom": 6
      },
      "Niger": {
        "centroid": [17.5768, 9.8913],
        "zoom": 6
      },
      "Norfolk Island": {
        "centroid": [-29.0292, 167.9583],
        "zoom": 6
      },
      "Nigeria": {
        "centroid": [9.1135, 7.9957],
        "zoom": 6
      },
      "Nicaragua": {
        "centroid": [12.8784, -85.581],
        "zoom": 7
      },
      "Netherlands": {
        "centroid": [52.1286, 5.5862],
        "zoom": 6
      },
      "Norway": {
        "centroid": [65.3756, 13.6008],
        "zoom": 6
      },
      "Nepal": {
        "centroid": [28.4185, 83.0688],
        "zoom": 6
      },
      "Nauru": {
        "centroid": [-0.5282, 166.9317],
        "zoom": 6
      },
      "Niue": {
        "centroid": [-19.054, -169.8494],
        "zoom": 6
      },
      "New Zealand": {
        "centroid": [-43.6656, 171.0074],
        "zoom": 6
      },
      "Oman": {
        "centroid": [20.8862, 57.0243],
        "zoom": 6.7
      },
      "Panama": {
        "centroid": [8.4209, -81.4811],
        "zoom": 7
      },
      "Peru": {
        "centroid": [-9.3149, -75.8066],
        "zoom": 6
      },
      "French Polynesia": {
        "centroid": [-17.688, -149.4451],
        "zoom": 6
      },
      "Papua New Guinea": {
        "centroid": [-6.6694, 144.3478],
        "zoom": 6
      },
      "Philippines": {
        "centroid": [15.6147, 120.7399],
        "zoom": 6
      },
      "Pakistan": {
        "centroid": [30.6947, 70.2714],
        "zoom": 6
      },
      "Poland": {
        "centroid": [52.0136, 19.1972],
        "zoom": 6
      },
      "Saint Pierre and Miquelon": {
        "centroid": [46.9642, -56.3267],
        "zoom": 6
      },
      "Pitcairn": {
        "centroid": [-24.376, -128.3268],
        "zoom": 6
      },
      "Puerto Rico": {
        "centroid": [18.2218, -64.4038],
        "zoom": 7
      },
      "Palestine": {
        "centroid": [32.5491, 35.4666],
        "zoom": 8
      },
      "Portugal": {
        "centroid": [39.6066, -8.2963],
        "zoom": 6
      },
      "Palau": {
        "centroid": [7.529, 134.5572],
        "zoom": 6
      },
      "Paraguay": {
        "centroid": [-23.4993, -58.4146],
        "zoom": 6
      },
      "Qatar": {
        "centroid": [25.3174, 51.1522],
        "zoom": 8
      },
      "Reunion": {
        "centroid": [-21.131, 55.537],
        "zoom": 6
      },
      "Romania": {
        "centroid": [45.9908, 24.2311],
        "zoom": 6
      },
      "Serbia": {
        "centroid": [44.2456, 21.0101],
        "zoom": 6
      },
      "Russia": {
        "centroid": [65.0969, 110.0304],
        "zoom": 6
      },
      "Rwanda": {
        "centroid": [-1.9436, 29.9873],
        "zoom": 6
      },
      "Saudi Arabia": {
        "centroid": [24.5136, 44.1943],
        "zoom": 6
      },
      "Solomon Islands": {
        "centroid": [-9.5987, 160.1487],
        "zoom": 6
      },
      "Seychelles": {
        "centroid": [-4.6839, 55.4928],
        "zoom": 6
      },
      "Sudan": {
        "centroid": [15.4506, 29.7844],
        "zoom": 6
      },
      "Sweden": {
        "centroid": [62.9927, 14.9497],
        "zoom": 6
      },
      "Singapore": {
        "centroid": [1.3405, 103.8302],
        "zoom": 6
      },
      "Saint Helena, Ascension and Tristan da Cunha": {
        "centroid": [-37.1159, -12.2823],
        "zoom": 6
      },
      "Slovenia": {
        "centroid": [46.1541, 14.634],
        "zoom": 6
      },
      "Svalbard and Jan Mayen": {
        "centroid": [78.4378, 18.5821],
        "zoom": 6
      },
      "Slovakia": {
        "centroid": [48.6813, 19.6543],
        "zoom": 6
      },
      "Sierra Leone": {
        "centroid": [8.4655, -11.875],
        "zoom": 6
      },
      "San Marino": {
        "centroid": [43.9433, 12.4605],
        "zoom": 6
      },
      "Senegal": {
        "centroid": [14.512, -14.6563],
        "zoom": 6
      },
      "Somalia": {
        "centroid": [5.1742, 46.8166],
        "zoom": 6
      },
      "Suriname": {
        "centroid": [3.9238, -56.1048],
        "zoom": 6
      },
      "South Sudan": {
        "centroid": [7.8795, 29.1116],
        "zoom": 6
      },
      "Sao Tome and Principe": {
        "centroid": [0.2162, 6.5945],
        "zoom": 6
      },
      "El Salvador": {
        "centroid": [13.8027, -88.9108],
        "zoom": 7
      },
      "Sint Maarten (Dutch part)": {
        "centroid": [18.0339, -63.0544],
        "zoom": 6
      },
      "Syria": {
        "centroid": [34.8522, 38.5585],
        "zoom": 6
      },
      "Eswatini": {
        "centroid": [-26.52, 31.4606],
        "zoom": 6
      },
      "Turks and Caicos": {
        "centroid": [21.7784, -71.7669],
        "zoom": 6
      },
      "Chad": {
        "centroid": [15.5973, 18.6422],
        "zoom": 6
      },
      "French Southern Territories": {
        "centroid": [-49.1974, 70.2177],
        "zoom": 6
      },
      "Togo": {
        "centroid": [8.6357, 1.0401],
        "zoom": 6
      },
      "Thailand": {
        "centroid": [13.1507, 101.6554],
        "zoom": 6
      },
      "Tajikistan": {
        "centroid": [38.8917, 70.945],
        "zoom": 6
      },
      "Tokelau": {
        "centroid": [-9.1757, -171.7801],
        "zoom": 6
      },
      "Timor Leste": {
        "centroid": [-8.8915, 125.7585],
        "zoom": 6
      },
      "Turkmenistan": {
        "centroid": [39.0689, 58.902],
        "zoom": 6
      },
      "Tunisia": {
        "centroid": [33.8627, 8.8412],
        "zoom": 6
      },
      "Tonga": {
        "centroid": [-21.168, -175.2735],
        "zoom": 6
      },
      "Turkey": {
        "centroid": [39.0251, 35.5135],
        "zoom": 6
      },
      "Trinidad and Tobago": {
        "centroid": [10.4437, -61.2616],
        "zoom": 8
      },
      "Tuvalu": {
        "centroid": [-7.4786, 178.6758],
        "zoom": 6
      },
      "Taiwan": {
        "centroid": [23.609, 120.8354],
        "zoom": 6
      },
      "Tanzania": {
        "centroid": [-6.4017, 34.2542],
        "zoom": 6
      },
      "Ukraine": {
        "centroid": [48.5409, 31.0081],
        "zoom": 6
      },
      "Uganda": {
        "centroid": [1.3719, 32.723],
        "zoom": 6
      },
      "US Minor Outlying Islands": {
        "centroid": [6.4052, -162.3503],
        "zoom": 6
      },
      "USA": {
        "centroid": [37.9507, -99.6531],
        "zoom": 6
      },
      "Uruguay": {
        "centroid": [-32.5625, -55.7993],
        "zoom": 6
      },
      "Uzbekistan": {
        "centroid": [41.5182, 63.3577],
        "zoom": 6
      },
      "Vatican City State": {
        "centroid": [41.9039, 12.4532],
        "zoom": 6
      },
      "Saint Vincent and Grenadines": {
        "centroid": [13.2528, -61.1949],
        "zoom": 6
      },
      "Venezuela": {
        "centroid": [6.4542, -66.9901],
        "zoom": 6
      },
      "British Virgin Islands": {
        "centroid": [18.4202, -64.6403],
        "zoom": 6
      },
      "US Virgin Islands": {
        "centroid": [17.7289, -64.7592],
        "zoom": 6
      },
      "Vietnam": {
        "centroid": [16.115, 107.6937],
        "zoom": 6
      },
      "Vanuatu": {
        "centroid": [-15.1569, 167.051],
        "zoom": 6
      },
      "Wallis and Futuna": {
        "centroid": [-13.2859, -176.2086],
        "zoom": 6
      },
      "Samoa": {
        "centroid": [-13.6222, -172.4389],
        "zoom": 6
      },
      "Kosovo": {
        "centroid": [42.5637, 20.9131],
        "zoom": 6
      },
      "Sovereign Base Areas of Akrotiri and Dhekelia": {
        "centroid": [35.0331, 33.7622],
        "zoom": 6
      },
      "Yemen": {
        "centroid": [15.822, 47.4901],
        "zoom": 6.3
      },
      "Mayotte": {
        "centroid": [-12.8253, 45.1494],
        "zoom": 6
      },
      "South Africa": {
        "centroid": [-28.6719, 23.9312],
        "zoom": 6
      },
      "Zambia": {
        "centroid": [-13.2073, 25.4621],
        "zoom": 6
      },
      "Zimbabwe": {
        "centroid": [-19.0547, 29.4113],
        "zoom": 6
      },
      "Middle East": {
        "centroid": [30.722906, 43.972538],
        "zoom": 4.5,
      },
      }
}

export default CountryCoords